import React from 'react';
import {ContactType} from "./contactType.ts";

interface ContactProps {
    data: ContactType
}

const ContactSection: React.FC<ContactProps> = ({data }) => {

    return   (
        <div className="block">
            <div className="border-b-2 border-[#989388] mb-3 pb-2">
                <h2 className="font-medium text-sm text-[#454b53] uppercase">{data.location}</h2>
            </div>
            {data.contacts.map(({ name, image, email, phone, address, status, location1, location2, city}, index) => {

                return (
                <div className="mt-4" key={index}>
                    <img
                        src={image}
                        alt={name}
                        className=" max-h-[131px] object-cover rounded-lg"
                    />
                    <div className="mt-2 min-h-[146px]">
                        <h2 className="font-bold text-sm text-[#454b53]">{name}</h2>
                        <h3 className="text-sm text-[#454b53]">{status}</h3>
                        <a href={`mailto:${email}`}  className="text-sm text-[#454b53]">{email}</a>
                        {phone && <h3 className="text-sm text-[#454b53]">{phone}</h3>}
                        {address &&  <h3 className="text-sm text-[#454b53]">{address}</h3>}
                        {location1 && <h3 className="text-sm text-[#454b53]">{location1}</h3>}
                        {location2 && <h3 className="text-sm text-[#454b53]">{location2}</h3>}
                     <h3 className="text-sm text-[#454b53]">{city ? city : ''}</h3>

                    </div>
                </div>)
            })}

        </div>
    );
};

export default ContactSection;
